// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mBm1qDW2 {
  background: #2c2c2c;
  color: #ffffff;
  padding: 1rem 0;
  margin-top: auto;
}
@media (max-width: 767px) {
  .mBm1qDW2 {
    padding: 1rem 0;
  }
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .mBm1qDW2 {
    margin-top: 0;
  }
}
@media (min-width: 1024px) {
  .mBm1qDW2 {
    height: 14rem;
  }
}
@media (min-width: 1024px) {
  .kHnEArfj {
    height: 20rem;
  }
}
.S0xm0KsE {
  margin: 0 auto;
  width: calc(100% - 1rem);
  max-width: 60rem;
  padding: 0;
}
@media (max-width: 767px) {
  .S0xm0KsE {
    width: calc(100% - 1rem);
    max-width: 60rem;
    padding: 0;
    box-sizing: border-box;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .S0xm0KsE {
    width: calc(100% - 2rem);
    max-width: 60rem;
    padding: 0;
    box-sizing: border-box;
  }
}
@media (min-width: 1024px) {
  .S0xm0KsE {
    width: calc(100% - 4rem);
    max-width: 60rem;
    padding: 0;
    box-sizing: border-box;
  }
}
.Hn8W7bZ4 {
  margin-bottom: 1rem;
  gap: 0.5rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-flex-wrap: wrap;
          flex-wrap: wrap;
}
@media (max-width: 767px) {
  .Hn8W7bZ4 {
    gap: 0.5rem;
  }
}
@media (min-width: 1024px) {
  .Hn8W7bZ4 {
    margin: 1.5rem 0;
  }
}
.FiMMP44y {
  position: relative;
}
.pXyrNXal {
  margin-bottom: 1rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
          flex-direction: column;
  gap: 0.5rem;
}
@media (max-width: 767px) {
  .pXyrNXal {
    gap: 0.25rem;
    margin-bottom: 0.5rem;
  }
}
.MHuIO6w0 {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  gap: 0.5rem;
  color: #ffffff;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 0.5rem;
  padding-left: 0.25rem;
  margin-bottom: 0.25rem;
}
@media (max-width: 767px) {
  .MHuIO6w0 {
    gap: 0.25rem;
  }
}
.KzIxDU7V {
  width: 3rem;
  height: 3rem;
  border-radius: 0.25rem;
  -o-object-fit: cover;
     object-fit: cover;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
  border-radius: 0.8rem;
}
@media (max-width: 767px) {
  .KzIxDU7V {
    width: 2.5rem;
    height: 2.5rem;
  }
}
.M0wbGlUz {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
          flex-direction: column;
  gap: 0.25rem;
}
.CoQ5Z5y8 {
  font-weight: 500;
  font-size: 0.875rem;
}
@media (max-width: 767px) {
  .CoQ5Z5y8 {
    font-size: 0.75rem;
  }
}
@media (min-width: 1024px) {
  .CoQ5Z5y8 {
    font-size: 1rem;
  }
}
._Dt2yeu8 {
  font-weight: normal;
  font-size: 0.75rem;
}
@media (max-width: 767px) {
  ._Dt2yeu8 {
    font-size: 0.75rem;
  }
}
@media (min-width: 1024px) {
  ._Dt2yeu8 {
    font-size: 0.875rem;
  }
}
.N6PQ2CLL {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  gap: 0.5rem;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
}
@media (max-width: 767px) {
  .N6PQ2CLL {
    gap: 0.25rem;
  }
}
.WyLSh8br {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  outline: none;
  font-family: inherit;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  gap: 0.25rem;
  padding: 0 1rem;
  background: #000;
  border: 1px solid #ffffff57;
  border-radius: 4px;
  color: #ffffff;
  font-size: 0.875rem;
  text-decoration: none;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  height: 2rem;
  min-width: 8rem;
}
.WyLSh8br:hover {
  background: rgba(0, 0, 0, 0.8);
}
@media (max-width: 767px) {
  .WyLSh8br {
    padding: 0 0.5rem;
    font-size: 0.75rem;
    height: 2rem;
  }
}
@media (min-width: 1024px) {
  .WyLSh8br {
    padding: 0 1.5rem 0 1rem;
    font-size: 1rem;
    height: 2.5rem;
    min-width: 9rem;
  }
}
.CXskO89E {
  width: 1.5rem;
  height: 1.5rem;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
  -o-object-fit: contain;
     object-fit: contain;
}
.ScnoHW9E {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  outline: none;
  font-family: inherit;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  gap: 0.25rem;
  color: #ffffff;
  font-size: 0.75rem;
  padding: 0 0.5rem;
  background: #000;
  border: 1px solid #ffffff57;
  border-radius: 4px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  height: 2rem;
  padding: 0 0.7rem 0 0.5rem;
  min-width: 9rem;
}
.ScnoHW9E:hover {
  background: rgba(0, 0, 0, 0.8);
}
@media (max-width: 767px) {
  .ScnoHW9E {
    font-size: 0.75rem;
    min-width: 7.5rem;
  }
}
@media (min-width: 1024px) {
  .ScnoHW9E {
    height: 2.5rem;
    font-size: 1rem;
  }
}
.iYtJOSlc {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  outline: none;
  font-family: inherit;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: inline-flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  gap: 0.25rem;
  height: 2rem;
  padding: 0 0.7rem 0 0.5rem;
  background: #000;
  border: 1px solid #ffffff57;
  border-radius: 4px;
  color: #ffffff;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  min-width: 8.25rem;
}
.iYtJOSlc:hover {
  background: rgba(0, 0, 0, 0.8);
}
@media (max-width: 767px) {
  .iYtJOSlc {
    min-width: 7.5rem;
  }
}
@media (min-width: 1024px) {
  .iYtJOSlc {
    height: 2.5rem;
    min-width: 8.75rem;
  }
}
.KVJTJm92 {
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
}
@media (min-width: 1024px) {
  .KVJTJm92 {
    font-size: 1rem;
  }
}
.R6RqkMKu {
  width: 1rem;
  height: 1rem;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
  margin-left: auto;
}
@media (max-width: 767px) {
  .R6RqkMKu {
    width: 0.875rem;
    height: 0.875rem;
  }
}
._2rrBtQYr {
  width: 1.7rem;
  height: 1.7rem;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
  -o-object-fit: contain;
     object-fit: contain;
}
@media (min-width: 1024px) {
  ._2rrBtQYr {
    width: 1.5rem;
    height: 1.5rem;
  }
}
.Cc005Rkd {
  width: 1rem;
  height: 1rem;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
  margin-left: auto;
  -webkit-transition: -webkit-transform 0.2s ease;
  transition: -webkit-transform 0.2s ease;
  transition: transform 0.2s ease;
  transition: transform 0.2s ease, -webkit-transform 0.2s ease;
}
@media (max-width: 767px) {
  .Cc005Rkd {
    width: 0.875rem;
    height: 0.875rem;
  }
}
@media (min-width: 1024px) {
  .Cc005Rkd {
    width: 1rem;
    height: 1rem;
  }
}
.wyvf1J11 {
  position: absolute;
  bottom: 100%;
  left: 0;
  margin-bottom: 0.25rem;
  background: #ffffff;
  border-radius: 0.25rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  min-width: 150px;
  overflow: hidden;
  z-index: 1000;
}
.O0GM9i2T {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  outline: none;
  font-family: inherit;
  width: 200px;
  padding: 0.5rem 1rem;
  text-align: left;
  color: #585858;
  font-size: 0.875rem;
  min-height: 2.75rem;
  min-width: 2.75rem;
}
.O0GM9i2T:hover {
  background: #f5f5f5;
}
.TNp3A7VY {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
          justify-content: flex-start;
  gap: 1rem;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: #fff;
}
@media (max-width: 767px) {
  .TNp3A7VY {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
            flex-direction: column;
    gap: 0.5rem;
    -webkit-box-align: start;
    -webkit-align-items: flex-start;
            align-items: flex-start;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .TNp3A7VY {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
            flex-direction: column;
    -webkit-box-align: start;
    -webkit-align-items: flex-start;
            align-items: flex-start;
  }
}
.S3SlltoT {
  color: rgba(255, 255, 255);
  text-decoration: none;
  font-size: 0.875rem;
  -webkit-transition: color 0.2s ease;
  transition: color 0.2s ease;
}
.S3SlltoT:hover {
  color: #ffffff;
}
@media (max-width: 767px) {
  .S3SlltoT {
    font-size: 0.75rem;
  }
}
@media (min-width: 1024px) {
  .S3SlltoT {
    font-size: 1rem;
  }
}
@media (hover: none) and (pointer: coarse) and (orientation: landscape) {
  .mBm1qDW2 {
    margin-top: 0;
    height: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/Footer.module.less","webpack://./src/styles/mixins.less"],"names":[],"mappings":"AAIA;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAHF;ACDE;EAAA;IDQE,eAAA;EAHF;AACF;AAKE;EAAA;IACE,aAAA;EAFF;AACF;ACOE;EAAA;IDFE,aAAA;EADF;AACF;ACEE;EAAA;IDIE,aAAA;EAFF;AACF;AAKA;EACE,cAAA;EACA,wBAAA;EACA,gBAAA;EACA,UAAA;AAHF;AC3BE;EAAA;IDiCE,wBAAA;IACA,gBAAA;IACA,UAAA;IACA,sBAAA;EAFF;AACF;ACvBE;EAAA;ID4BE,wBAAA;IACA,gBAAA;IACA,UAAA;IACA,sBAAA;EADF;AACF;ACzBE;EAAA;ID6BE,wBAAA;IACA,gBAAA;IACA,UAAA;IACA,sBAAA;EAAF;AACF;AAGA;EACE,mBAAA;EACA,WAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,uBAAA;UAAA,eAAA;AADF;AC1DE;EAAA;ID8DE,WAAA;EAAF;AACF;AC7CE;EAAA;ID+CE,gBAAA;EAEF;AACF;AACA;EACE,kBAAA;AACF;AAGA;EACE,mBAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;EAAA,8BAAA;UAAA,sBAAA;EACA,WAAA;AADF;AC7EE;EAAA;IDiFE,YAAA;IACA,qBAAA;EAAF;AACF;AAGA;EACE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,8CAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;AADF;AC7FE;EAAA;IDiGE,YAAA;EAAF;AACF;AAGA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,oBAAA;KAAA,iBAAA;EACA,sBAAA;UAAA,cAAA;EACA,qBAAA;AADF;AC1GE;EAAA;ID8GE,aAAA;IACA,cAAA;EAAF;AACF;AAGA;EACE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;EAAA,8BAAA;UAAA,sBAAA;EACA,YAAA;AADF;AAIA;EACE,gBAAA;EACA,mBAAA;AAFF;ACzHE;EAAA;ID8HE,kBAAA;EADF;AACF;AC5GE;EAAA;IDgHE,eAAA;EAAF;AACF;AAGA;EACE,mBAAA;EACA,kBAAA;AADF;ACvIE;EAAA;ID2IE,kBAAA;EAAF;AACF;AC1HE;EAAA;ID6HE,mBAAA;EACF;AACF;AAEA;EACE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,WAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;AAAF;ACtJE;EAAA;IDyJE,YAAA;EACF;AACF;AAEA;ECzDE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,oBAAA;EDqDA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,qBAAA;EACA,iCAAA;EAAA,yBAAA;EACA,YAAA;EACA,eAAA;AAMF;AALE;EACE,8BAAA;AAOJ;ACpLE;EAAA;IDiLE,iBAAA;IACA,kBAAA;IACA,YAAA;EAOF;AACF;ACzKE;EAAA;IDqKE,wBAAA;IACA,eAAA;IACA,cAAA;IACA,eAAA;EAQF;AACF;AALA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;UAAA,cAAA;EACA,sBAAA;KAAA,mBAAA;AAOF;AAHA;EClGE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,oBAAA;ED8FA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,2BAAA;EACA,kBAAA;EACA,iCAAA;EAAA,yBAAA;EACA,YAAA;EACA,0BAAA;EACA,eAAA;AAWF;AATE;EACE,8BAAA;AAWJ;AClOE;EAAA;ID2NE,kBAAA;IACA,iBAAA;EAWF;AACF;ACtNE;EAAA;ID8ME,cAAA;IACA,eAAA;EAYF;AACF;AATA;ECjIE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,oBAAA;ED6HA,2BAAA;EAAA,4BAAA;EAAA,oBAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,0BAAA;EACA,gBAAA;EACA,2BAAA;EACA,kBAAA;EACA,cAAA;EACA,iCAAA;EAAA,yBAAA;EACA,kBAAA;AAiBF;AAfE;EACE,8BAAA;AAiBJ;ACrQE;EAAA;IDwPE,iBAAA;EAiBF;AACF;ACxPE;EAAA;ID0OE,cAAA;IACA,kBAAA;EAkBF;AACF;AAfA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAiBF;ACpQE;EAAA;IDsPE,eAAA;EAkBF;AACF;AAfA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;UAAA,cAAA;EACA,iBAAA;AAiBF;ACjSE;EAAA;IDmRE,eAAA;IACA,gBAAA;EAkBF;AACF;AAfA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;UAAA,cAAA;EACA,sBAAA;KAAA,mBAAA;AAiBF;AC3RE;EAAA;ID4QE,aAAA;IACA,cAAA;EAmBF;AACF;AAhBA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;UAAA,cAAA;EACA,iBAAA;EACA,+CAAA;EAAA,uCAAA;EAAA,+BAAA;EAAA,4DAAA;AAkBF;AC1TE;EAAA;ID2SE,eAAA;IACA,gBAAA;EAmBF;AACF;AC9SE;EAAA;ID8RE,WAAA;IACA,YAAA;EAoBF;AACF;AAjBA;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yCAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;AAmBF;AAhBA;EC9NE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,oBAAA;ED0NA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;ECzNA,mBAAA;EACA,kBAAA;ADkPF;AAvBE;EACE,mBAAA;AAyBJ;AArBA;EC3QE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,uBAAA;EAAA,mCAAA;UAAA,2BAAA;ED2QA,SAAA;EACA,iBAAA;EACA,8CAAA;EACA,WAAA;AAyBF;AC9WE;EAAA;IDwVE,4BAAA;IAAA,6BAAA;IAAA,8BAAA;YAAA,sBAAA;IACA,WAAA;IACA,wBAAA;IAAA,+BAAA;YAAA,uBAAA;EA0BF;AACF;ACzWE;EAAA;IDiVE,4BAAA;IAAA,6BAAA;IAAA,8BAAA;YAAA,sBAAA;IACA,wBAAA;IAAA,+BAAA;YAAA,uBAAA;EA4BF;AACF;AAzBA;EACE,0BAAA;EACA,qBAAA;EACA,mBAAA;EACA,mCAAA;EAAA,2BAAA;AA2BF;AAzBE;EACE,cAAA;AA2BJ;ACpYE;EAAA;ID6WE,kBAAA;EA2BF;AACF;ACvXE;EAAA;ID8VE,eAAA;EA6BF;AACF;AA1BA;EACE;IACE,aAAA;IACA,YAAA;EA4BF;AACF","sourcesContent":["@import '@/styles/variables.less';\n@import '@/styles/mixins.less';\n@import '@/pages/Products/productsPageLayoutVars.less';\n\n.footer {\n  background: #2c2c2c; // 深灰色背景\n  color: @white;\n  padding: @spacing-md 0;\n  margin-top: auto;\n  // Footer在页面内容最底部，底部导航栏是浮动固定的，所以Footer正常显示即可\n\n  .mobile({\n    padding: @spacing-md 0;\n  });\n\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    margin-top: 0;\n  }\n\n  .desktop({\n    height: 14rem;\n  });\n}\n\n.footerWithDownload {\n  .desktop({\n    height: 20rem;\n  });\n}\n\n.container {\n  margin: 0 auto;\n  width: calc(100% - @products-page-padding-x-mobile-total);\n  max-width: @products-catalog-max-width;\n  padding: 0;\n\n  .mobile({\n    width: calc(100% - @products-page-padding-x-mobile-total);\n    max-width: @products-catalog-max-width;\n    padding: 0;\n    box-sizing: border-box;\n  });\n\n  .tablet({\n    width: calc(100% - @products-page-padding-x-tablet-total);\n    max-width: @products-catalog-max-width;\n    padding: 0;\n    box-sizing: border-box;\n  });\n\n  .desktop({\n    width: calc(100% - @products-page-padding-x-desktop-total);\n    max-width: @products-catalog-max-width;\n    padding: 0;\n    box-sizing: border-box;\n  });\n}\n\n.topSection {\n  margin-bottom: @spacing-md;\n  gap: @spacing-sm;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n\n  .mobile({\n    gap: @spacing-sm;\n  });\n  .desktop({\n    margin: 1.5rem 0;\n  });\n}\n\n.footerActionDropdown {\n  position: relative;\n}\n\n// 下载按钮区域\n.downloadSection {\n  margin-bottom: @spacing-md;\n  display: flex;\n  flex-direction: column;\n  gap: @spacing-sm;\n\n  .mobile({\n    gap: @spacing-xs;\n    margin-bottom: @spacing-sm;\n  });\n}\n\n.downloadTitle {\n  display: flex;\n  align-items: center;\n  gap: @spacing-sm;\n  color: @white;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  padding-top: @spacing-sm;\n  padding-left: @spacing-xs;\n  margin-bottom: @spacing-xs;\n\n  .mobile({\n    gap: @spacing-xs;\n  });\n}\n\n.downloadGameIcon {\n  width: 3rem;\n  height: 3rem;\n  border-radius: @border-radius-sm;\n  object-fit: cover;\n  flex-shrink: 0;\n  border-radius: 0.8rem;\n\n  .mobile({\n    width: 2.5rem;\n    height: 2.5rem;\n  });\n}\n\n.downloadTitleText {\n  display: flex;\n  flex-direction: column;\n  gap: @spacing-xs;\n}\n\n.downloadGameName {\n  font-weight: 500;\n  font-size: @font-size-sm;\n\n  .mobile({\n    font-size: @font-size-xs;\n  });\n\n  .desktop({\n    font-size: @font-size-md;\n  });\n}\n\n.downloadPrompt {\n  font-weight: normal;\n  font-size: @font-size-xs;\n\n  .mobile({\n    font-size: @font-size-xs;\n  });\n\n  .desktop({\n    font-size: @font-size-sm;\n  });\n}\n\n.downloadButtons {\n  display: flex;\n  gap: @spacing-sm;\n  align-items: center;\n\n  .mobile({\n    gap: @spacing-xs;\n  });\n}\n\n.downloadButton {\n  .button-reset();\n  display: flex;\n  align-items: center;\n  gap: @spacing-xs;\n  padding: 0 @spacing-md;\n  background: #000;\n  border: 1px solid #ffffff57;\n  border-radius: 4px;\n  color: @white;\n  font-size: @font-size-sm;\n  text-decoration: none;\n  transition: all 0.2s ease;\n  height: 2rem;\n  min-width: 8rem;\n  &:hover {\n    background: rgba(0, 0, 0, 0.8);\n  }\n\n  .mobile({\n    padding: 0 @spacing-sm;\n    font-size: @font-size-xs;\n    height: 2rem;\n  });\n\n  .desktop({\n    padding: 0 @spacing-lg 0 @spacing-md;\n    font-size: @font-size-md;\n    height: 2.5rem;\n    min-width: 9rem;\n  });\n}\n\n.downloadIcon {\n  width: 1.5rem;\n  height: 1.5rem;\n  flex-shrink: 0;\n  object-fit: contain;\n\n}\n\n.languageButton {\n  .button-reset();\n  display: flex;\n  align-items: center;\n  gap: @spacing-xs;\n  color: @white;\n  font-size: @font-size-xs;\n  padding: 0 @spacing-sm;\n  background: #000; // 黑色背景\n  border: 1px solid #ffffff57;\n  border-radius: 4px; \n  transition: all 0.2s ease;\n  height: 2rem;\n  padding: 0 0.7rem 0 0.5rem;\n  min-width: 9rem;\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.8);\n  }\n\n  .mobile({\n    font-size: @font-size-xs;\n    min-width: 7.5rem;\n  });\n\n  .desktop({\n    height: 2.5rem;\n    font-size: @font-size-md;\n  })\n}\n\n.supportEntryButton {\n  .button-reset();\n  display: inline-flex;\n  align-items: center;\n  gap: @spacing-xs;\n  height: 2rem;\n  padding: 0 0.7rem 0 0.5rem;\n  background: #000;\n  border: 1px solid #ffffff57;\n  border-radius: 4px;\n  color: @white;\n  transition: all 0.2s ease;\n  min-width: 8.25rem;\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.8);\n  }\n\n  .mobile({\n    min-width: 7.5rem;\n  });\n\n  .desktop({\n    height: 2.5rem;\n    min-width: 8.75rem;\n  });\n}\n\n.supportEntryText {\n  font-size: @font-size-xs;\n  font-weight: 500;\n  line-height: 1;\n  white-space: nowrap;\n\n  .desktop({\n    font-size: @font-size-md;\n  });\n}\n\n.supportEntryArrow {\n  width: 1rem;\n  height: 1rem;\n  flex-shrink: 0;\n  margin-left: auto;\n\n  .mobile({\n    width: 0.875rem;\n    height: 0.875rem;\n  });\n}\n\n.buttonIcon {\n  width: 1.7rem; // 14px\n  height: 1.7rem; // 14px\n  flex-shrink: 0;\n  object-fit: contain;\n  .desktop({\n    width: 1.5rem;\n    height: 1.5rem;\n  });\n}\n\n.chevronIcon {\n  width: 1rem;\n  height: 1rem;\n  flex-shrink: 0;\n  margin-left: auto;\n  transition: transform 0.2s ease;\n\n  .mobile({\n    width: 0.875rem;\n    height: 0.875rem;\n  });\n\n  .desktop({\n    width: 1rem;\n    height: 1rem;\n  });\n}\n\n.languageDropdown {\n  position: absolute;\n  bottom: 100%;\n  left: 0;\n  margin-bottom: @spacing-xs;\n  background: @white;\n  border-radius: @border-radius-sm;\n  box-shadow: @box-shadow-md;\n  min-width: 150px;\n  overflow: hidden;\n  z-index: @z-index-dropdown;\n}\n\n.languageOption {\n  .button-reset();\n  width: 200px;\n  padding: @spacing-sm @spacing-md;\n  text-align: left;\n  color: @text-color;\n  font-size: @font-size-sm;\n  .touch-friendly();\n\n  &:hover {\n    background: @background-color;\n  }\n}\n\n.bottomSection {\n  .flex-start();\n  gap: @spacing-md;\n  padding-top: 2rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  color: #fff;\n\n  .mobile({\n    flex-direction: column;\n    gap: @spacing-sm;\n    align-items: flex-start;\n  });\n  .tablet({\n    flex-direction: column;\n    align-items: flex-start;\n  });\n}\n\n.link {\n  color: rgba(255, 255, 255);\n  text-decoration: none;\n  font-size: @font-size-sm;\n  transition: color 0.2s ease;\n\n  &:hover {\n    color: @white;\n  }\n\n  .mobile({\n    font-size: @font-size-xs;\n  });\n  .desktop({\n    font-size: @font-size-md;\n  })\n}\n\n@media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n  .footer {\n    margin-top: 0;\n    height: auto;\n  }\n}\n","@import './variables.less';\n\n// 响应式 Mixins\n.mobile(@rules) {\n  @media (max-width: 767px) {\n    @rules();\n  }\n}\n\n.mobileNarrow(@rules) {\n  @media (max-width: 413px) {\n    @rules();\n  }\n}\n\n.tablet(@rules) {\n  @media (min-width: 768px) and (max-width: 1023px) {\n    @rules();\n  }\n}\n\n.desktop(@rules) {\n  @media (min-width: 1024px) {\n    @rules();\n  }\n}\n\n.tablet-up(@rules) {\n  @media (min-width: 768px) {\n    @rules();\n  }\n}\n\n// 紧凑 PC（1024~1728 宽）：首页 banner 缩小与垂直微调\n.homeCompactPc(@rules) {\n  @media (min-width: 1024px) and (max-width: 1728px) {\n    @rules();\n  }\n}\n\n.homeCompactPcShort(@rules) {\n  @media (min-width: 1024px) and (max-width: 1728px) and (max-height: 1000px) {\n    @rules();\n  }\n}\n\n// 宽屏 PC（>1728 宽）：首页 banner 放大\n.homeWidePc(@rules) {\n  @media (min-width: 1729px) {\n    @rules();\n  }\n}\n\n// 浏览器放大/缩小时：横向裁切装饰溢出，纵向允许滚动避免内容显示不全\n.zoomScrollablePage() {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n// Flexbox Mixins\n.flex-center() {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.flex-between() {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.flex-start() {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n// 文本省略\n.text-ellipsis() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-ellipsis-multi(@lines: 2) {\n  display: -webkit-box;\n  -webkit-line-clamp: @lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n// 清除浮动\n.clearfix() {\n  &::after {\n    content: '';\n    display: table;\n    clear: both;\n  }\n}\n\n// 按钮重置\n.button-reset() {\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  outline: none;\n  font-family: inherit;\n}\n\n// 触摸友好\n.touch-friendly() {\n  min-height: 2.75rem; // 44px\n  min-width: 2.75rem; // 44px\n}\n\n// 可滚动弹窗蒙版：背景 fixed 铺满视口，内容区单独滚动，避免移动端滑出未覆盖区域\n.modalOverlayBackdrop(@bg: rgba(0, 0, 0, 0.55)) {\n  box-sizing: border-box;\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n  touch-action: pan-y;\n\n  &::before {\n    content: '';\n    position: fixed;\n    inset: 0;\n    background: @bg;\n    backdrop-filter: blur(4px);\n    -webkit-backdrop-filter: blur(4px);\n    z-index: -1;\n    pointer-events: none;\n  }\n}\n\n// 触屏设备横屏时高度很矮，弹窗蒙版必须允许自身滚动，并从顶部开始排布。\n.touchLandscapeModalOverlay(@padding-y: @spacing-sm, @padding-x: @spacing-md) {\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    display: block;\n    align-items: initial;\n    justify-content: initial;\n    padding: @padding-y @padding-x;\n    overflow-x: hidden;\n    overflow-y: auto;\n    overscroll-behavior: contain;\n    -webkit-overflow-scrolling: touch;\n    touch-action: pan-y;\n\n    &::after {\n      content: '';\n      display: block;\n      height: @padding-y;\n    }\n  }\n}\n\n.touchLandscapeModalBox(@max-height-gap: (@spacing-sm * 2)) {\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    max-height: calc(var(--app-viewport-height, 100dvh) - @max-height-gap);\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `mBm1qDW2`,
	"footerWithDownload": `kHnEArfj`,
	"container": `S0xm0KsE`,
	"topSection": `Hn8W7bZ4`,
	"footerActionDropdown": `FiMMP44y`,
	"downloadSection": `pXyrNXal`,
	"downloadTitle": `MHuIO6w0`,
	"downloadGameIcon": `KzIxDU7V`,
	"downloadTitleText": `M0wbGlUz`,
	"downloadGameName": `CoQ5Z5y8`,
	"downloadPrompt": `_Dt2yeu8`,
	"downloadButtons": `N6PQ2CLL`,
	"downloadButton": `WyLSh8br`,
	"downloadIcon": `CXskO89E`,
	"languageButton": `ScnoHW9E`,
	"supportEntryButton": `iYtJOSlc`,
	"supportEntryText": `KVJTJm92`,
	"supportEntryArrow": `R6RqkMKu`,
	"buttonIcon": `_2rrBtQYr`,
	"chevronIcon": `Cc005Rkd`,
	"languageDropdown": `wyvf1J11`,
	"languageOption": `O0GM9i2T`,
	"bottomSection": `TNp3A7VY`,
	"link": `S3SlltoT`
};
export default ___CSS_LOADER_EXPORT___;
